<template>
  <div class="sys-setting-page">
    <el-form :model="queryCondition" :inline="true" label-position="left">
      <el-form-item label="说明">
        <el-input v-model="queryCondition.TypeName" placeholder="输入说明"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input v-model="queryCondition.TypeCode" placeholder="输入分类编码"></el-input>
      </el-form-item>
      <el-form-item label="配置名">
        <el-input v-model="queryCondition.SetName" placeholder="输入配置名"></el-input>
      </el-form-item>
      <el-form-item label="配置值">
        <el-input v-model="queryCondition.SetValue" placeholder="输入配置值"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-radio-group v-model="queryCondition.Enable">
          <el-radio :label="100">全部</el-radio>
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onBtnSearch">查询</el-button>
        <el-button type="primary" @click="onAddSetting">添加</el-button>
      </el-form-item>
    </el-form>

    <div>
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :current-page="queryCondition.pageindex" :page-sizes="[15,20,30,50,100]" :page-size="queryCondition.pagesize" layout="total,sizes,prev,pager,next,jumper" :total="queryCondition.count" >
      </el-pagination>
    </div>
    <el-table :data="setDatas" border style="width: 100%" v-loading="loading">
      <el-table-column prop="TypeName" label="说明" width="180"></el-table-column>
      <el-table-column prop="TypeCode" label="分类编码" width="180"></el-table-column>
      <el-table-column prop="SetName" label="配置名" width="180"></el-table-column>
      <el-table-column prop="SetValue" label="配置值" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Enable" label="有效" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Enable==1?'success':'info'">{{scope.row.Enable==1?'启用':'禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="changeEnable(scope.row)" :type="scope.row.Enable==1?'warning':'success'" size="mini">{{scope.row.Enable==1?'禁用':'启用'}}</el-button>
          <el-button @click="onEditSetting(scope.row)" type="primary" size="mini">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加/修改系统设置" :visible.sync="dlgAddSetting">
      <el-form label-width="80px" :model="editSetting" :rules="rules" ref="setForm">
        <el-form-item label="说明" prop="TypeName">
          <el-input v-model="editSetting.TypeName" placeholder="输入说明"></el-input>
        </el-form-item>
        <el-form-item label="分类编码" prop="TypeCode">
          <el-input v-model="editSetting.TypeCode" placeholder="输入分类编码"></el-input>
        </el-form-item>
        <el-form-item label="配置名" prop="SetName">
          <el-input v-model="editSetting.SetName" placeholder="输入配置名"></el-input>
        </el-form-item>
        <el-form-item label="配置值" prop="SetValue">
          <el-input type="textarea" v-model="editSetting.SetValue" rows="7"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-switch v-model="editSetting.Enable" active-value="0" inactive-value="1" active-color="#dcdfe6" inactive-color="#13ce66" active-text="禁用" inactive-text="启用"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgAddSetting = false" :disabled="loading">取 消</el-button>
        <el-button type="primary" @click="onSaveSetting" :disabled="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {searchSettings,saveSetting} from '../../api/setting'

export default {
  data() {
    return {
      queryCondition: {TypeName:"", TypeCode:"", SetName:"", SetValue:"", Enable: 100, pageindex: 1, pagesize: 20, count: 0},
      setDatas:[],
      dlgAddSetting:false,
      editSetting: {ID:0, TypeCode:"", TypeName:"", SetName:"", SetValue:"", Enable: 1},
      loading:false,
      rules:{
        TypeName:[{ required: true, message: '请输入说明', trigger: 'blur' }],
        TypeCode:[{ required: true, message: '请输入分类编码', trigger: 'blur' }],
        SetName:[{ required: true, message: '请输入配置名', trigger: 'blur' }]
      }
    };
  },
  created(){
    this.onSearch();
  },
  methods:{
    changeEnable:function(setting){
      var saveSet = Object.assign({}, setting, {Enable: setting.Enable == 1?0:1});
      this.loading = true
      saveSetting(saveSet).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.$notify.success({title: '成功',message: '保存成功'})
          setting.Enable = saveSet.Enable;
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'修改失败',message:err.statusText})
        this.loading = false
      });
    },
    onBtnSearch:function(){
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onSearch:function(){
      var that = this;
      this.loading = true
      searchSettings(this.queryCondition).then(resp=>{
        that.loading = false
        if (resp.data.code == 100){
          that.setDatas = resp.data.data.Data;
          that.queryCondition.count = resp.data.data.Count;
        }else{
          that.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        that.loading = false
        that.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    onAddSetting:function(){
      this.editSetting = {ID:0, TypeCode:"", TypeName:"", SetName:"", SetValue:"", Enable: 1};
      this.dlgAddSetting = true;
      if (this.$refs['setForm'])this.$refs['setForm'].resetFields();
    },
    onEditSetting:function(setting){
      this.editSetting = Object.assign({}, setting);
      this.editSetting.Enable = this.editSetting.Enable + '';
      this.dlgAddSetting = true;
      if (this.$refs['setForm'])this.$refs['setForm'].resetFields();
    },
    onSaveSetting:function(){
      var isValid = false
      this.$refs['setForm'].validate((valid) => {
        isValid = valid
        return valid;
      });
      if(!isValid){
        this.$notify.info({title: '警告',message: "请按要求填写数据"})
        return
      }

      this.dlgAddSetting = false;
      this.editSetting.Enable = this.editSetting.Enable * 1;
      this.loading = true
      saveSetting(this.editSetting).then(resp=>{
        this.loading = false
        if (resp.data.code == 100){
          this.$notify.success({title: '成功',message: '保存成功'})
          if (this.editSetting.ID == 0){
            this.onSearch();
          }else{
            for(var i = 0; i < this.setDatas.length; i++){
              if (this.setDatas[i].ID == this.editSetting.ID){
                this.setDatas[i] = Object.assign(this.setDatas[i], this.editSetting);
                break;
              }
            }
          }
        }else{
          this.$notify.error({title: '失败',message: resp.data.msg})
        }
      },err=>{
        this.$notify.error({title:'保存',message:err.statusText})
        this.loading = false
      });
    },
    onSizeChange(curSize){
      this.queryCondition.pagesize = curSize;
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onCurrentChange(curIndex){
      this.queryCondition.pageindex = curIndex;
      this.onSearch();
    }
  }
}
</script>
